module.exports = __webpack_public_path__ + "img/22072801.8f76ff5b.jpg";